// When mixed in this requires also a method defined like
// methods: {
//     getPriceChangeConfig() {
//         return {
//             job_view: this.job_view,
//             price_selling: true,
//             price_purchasing: true,
//             price_lists: true,
//         };
//     },
// },

export default {
  computed: {
    cancelationsWithPriceChange() {
      let { job_view, price_purchasing, price_selling, price_lists } =
        this.getPriceChangeConfig();
      return job_view.cancellations.filter((cancellation) => {
        let match = false;
        if (cancellation.old_price_lists && price_lists) {
          match =
            match ||
            cancellation.old_price_purchasing != cancellation.new_price_selling;
        }
        if (cancellation.old_price_purchasing && price_purchasing) {
          match =
            match ||
            cancellation.old_price_purchasing != cancellation.new_price_selling;
        }
        if (cancellation.old_price_selling && price_selling) {
          match =
            match ||
            cancellation.old_price_selling != cancellation.new_price_selling;
        }
        return match;
      });
    },
    firstCancelationWithPriceChange() {
      return this.cancelationsWithPriceChange.length
        ? this.cancelationsWithPriceChange[
            this.cancelationsWithPriceChange.length - 1
          ]
        : null;
    },
    lastCancelationWithPriceChange() {
      return this.cancelationsWithPriceChange.length
        ? this.cancelationsWithPriceChange[0]
        : null;
    },
  },
};
